import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';

export type UserType = 'experience' | 'business' | 'regional' | 'gemeinde' | 'verein' | 'firma';

export interface BadgeConfig {
  label: string;
  severity: "info" | "success" | "warn" | "danger" | "secondary" | "contrast";
}

@Component({
  selector: 'app-user-type-badge',
  standalone: true,
  imports: [CommonModule, BadgeModule],
  template: `
    <p-badge
      [value]="badgeConfig.label"
      [severity]="badgeConfig.severity"
      size="small">
    </p-badge>
  `
})
export class UserTypeBadgeComponent {
  @Input() type: string = '';
  @Input() customLabel?: string;

  get badgeConfig(): BadgeConfig {
    const normalizedType = this.type?.toLowerCase() || '';

    // Use custom label if provided, otherwise use the formatted type
    const label = this.customLabel || this.getFormattedLabel(normalizedType);

    switch (normalizedType) {
      case 'privatperson':
        return {
          label: label,
          severity: 'info',
        };

      case 'business':
      case 'gemeinde':
      case 'verein':
      case 'firma':
        return {
          label: label,
          severity: 'success',
        };

      case 'regional':
        return {
          label: label,
          severity: 'warn',
        };

      default:
        return {
          label: 'Privatperson',
          severity: 'info',
        };
    }
  }

  private getFormattedLabel(type: string): string {
    switch (type) {
      case 'experience':
        return 'BENUTZER';
      case 'business':
        return 'BUSINESS';
      case 'gemeinde':
        return 'GEMEINDE';
      case 'verein':
        return 'VEREIN';
      case 'firma':
        return 'FIRMA';
      case 'regional':
        return 'REGION';
      case 'privatperson':
        return 'PRIVAT';
      default:
        return type.toUpperCase();
    }
  }
}